import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from "react";
import { Tooltip } from "../tooltip/Tooltip";
import { Ink } from "../ink/index";
import * as Styled from "./ToolbarButton.styled";
export const ToolbarLinkButton = (props) => {
    const { icon, label, ...otherProps } = props;
    const linkRef = useRef(null);
    return (_jsxs(_Fragment, { children: [_jsxs(Styled.ToolbarLinkButton, { ref: linkRef, ...otherProps, children: [icon, _jsx(Ink, { opacity: 0.05 })] }), _jsx(Tooltip, { mode: "name", delay: 500, triggerRef: linkRef, contents: label, placement: "top", fallbackPlacements: ["bottom", "auto"] })] }));
};
